import React from "react";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useOverviewContext } from "@features/overview-v2/hooks";
import { type OverviewSavedView } from "@features/overview-v2/types";

import { SavedViewsMenuLoadingRow } from "./saved-views-menu-loading-row";

interface DeleteSavedViewsProps {
  readonly savedView: OverviewSavedView;
  readonly onClose: () => void;
}

export const DeleteSavedViews = ({
  savedView,
  onClose,
}: DeleteSavedViewsProps) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const {
    deleteSavedView,
    saveViewsSavingState: { isDeleting },
    createHiddenSavedViewTemplate,
  } = useOverviewContext();

  return (
    <div className="text-xs w-full h-full flex items-center bg-inherit z-1">
      <SavedViewsMenuLoadingRow
        isLoading={isDeleting === savedView.id}
        text="Deleting..."
      >
        <div className="text-xs flex items-center">
          <button
            className="text-mars mr-3 hover:bg-v2-primary px-3 py-1 rounded"
            onClick={async () => {
              if (savedView.is_template) {
                await createHiddenSavedViewTemplate(savedView.id, {
                  errorMessage: "There was an error deleting the view.",
                  onSuccess: () => onClose(),
                });
              } else {
                await deleteSavedView(savedView.id, {
                  errorMessage: "There was an error deleting the view.",
                  onSuccess: () => onClose(),
                });
              }

              const additionalActionInfo = savedView.is_template
                ? "Hide overview saved view template"
                : "Delete overview saved view";
              prettyLogEventPage({
                domain: "Saved Views",
                action: "onClick",
                additionalActionInfo,
                data: {
                  pageContext: { savedViewId: savedView.id },
                },
              });
            }}
          >
            YES, DELETE
          </button>
          <button
            className="text-cosmic+1 hover:bg-v2-primary px-3 py-1 rounded"
            onClick={() => onClose()}
          >
            CANCEL
          </button>
        </div>
      </SavedViewsMenuLoadingRow>
    </div>
  );
};
